import React, { Component } from 'react';
import $ from 'jquery';
import DataTablesCreate from "./DataTablesCreate";

let headers = [
    {title: 'Número de pago'},//1
    {title: 'Fecha de vencimiento'},//2
    {title: 'Fecha de contabilización'},//3
    {title: 'Total'},//4
    ];

class PaymentListModaL extends Component {
    componentDidMount(): void {
        this.closeAction();
    }

    closeTransaction = async () => {
        $('#paymentListModaL').modal('hide');
    }

    closeAction = () => {
        const { cleanData } = this.props;
        $('#paymentListModaL').on('hidden.bs.modal', function () {
            cleanData();
        });
    };  


    render() {
        const {data, selectAccount} = this.props;

        if(data.length === 0){
            return <div className="modal fade bd-example-modal-lg bgtransparent"  role="dialog"  id="paymentListModaL"></div>;
        }


        return (
            <div>
                <div className="modal fade bd-example-modal-lg modal-open scroll"  role="dialog"  id="paymentListModaL" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-open" role="document">
                        <div className="modal-content">

                            <div className="modal-header text-white" style={{backgroundColor:'#343a40',borderRadius:'0'}}>
                                <h4 className="modal-title" id="modal-basic-title ">Lista de pagos</h4>
                                <button type="button" className="close" onClick={this.closeTransaction} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div  className="w-100 table-scroll tab-pane fade show active "  aria-labelledby="nav-home-tab-Contenido" >
                                                <table className="table response" style={{marginBottom: 0}}>
                                                    <tbody>
                                                    <DataTablesCreate data={data} headers={headers} view={"paymentListModaL"} action={selectAccount}/>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeTransaction}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PaymentListModaL;